function scrollProgress() {
    if ( ! $j('div.scroll-progress').length ) {
        return;
    }
    //GET VARIABLES
    $j(window).on('ready load resizeEnd', function() {
        var $articleContent = $j('div.scroll-progress'),
                panelHeight = 90,
                articleOffset = $articleContent.offset();

        window.headerHeight = $j('#header').height();
        window.articleHeight = $articleContent.height();
        window.windowHeight = $j(window).height();
        window.articleOffsetTop = articleOffset.top - panelHeight;
    });
    //ON SCROLL
    $j(window).on('scroll ready load resize resizeEnd', function(event) {
        var scrollTop = $j(window).scrollTop();
        var scrollProgress = ((scrollTop - window.articleOffsetTop) / (window.articleHeight - window.windowHeight / 6));
        //log('scrolled', scrollTop, scrollProgress);
        // HEADER ANIMATION
		var scrollAmount = 100 - Math.round(100 * scrollProgress);
        if (scrollProgress >= 0 && scrollProgress <= 1) {
            $j('.progress-bar').addClass('active');
			$j('.progress-cover').css('width', scrollAmount + "%");
            $j('.progress-container').addClass('active');
        } else if (scrollProgress > 1) {
            $j('.progress-bar').removeClass('active');
			$j('.progress-cover').css('width', "0%");
            $j('.progress-container').removeClass('active');
        } else {
            $j('.progress-bar').removeClass('active');
			$j('.progress-cover').css('width', "100%");
            $j('.progress-container').removeClass('active');
        }
    });
}



var scrollerfn = null;
var _sps = 50;
var scrolledtop = 1;
var prevScrollpos = window.pageYOffset;

$j(window).on('scroll', function() {
    clearTimeout(scrollerfn);
    scrollerfn = setTimeout(scroller, _sps);
});

/*
jQuery(window).bind('scroll', function() {
	if ($(window).scrollTop() > 130) {
		//$('#header').addClass('fixed');
        $('#oc').stop(false,false).animate({'top':"0px"}, {duration:600, easing:'easeOutCirc'});
		$('#oc').removeClass('hidden');
	}	else {
		//$('#header').removeClass('fixed');
        $('#oc').stop(false,false).animate({'top':"-80px"}, {duration:400, easing:'easeOutCirc'});
		$('#oc').addClass('hidden');
	}
});
*/

function fpScroller() {
    if ( $j('body.scrolling').length ) {
        return;
    }
    $j('section.view-region.inview').removeClass('inview');
    var inview = $j('section.view-region:in-viewport:first').find('.anchor>a').attr('id');
    if ( inview == 'overview' ) {
        $j('.fp-header-action ul.cycle-slideshow').cycle('resume');
    } else {
        $j('.fp-header-action ul.cycle-slideshow.cycle-running').cycle('pause');
    }
    $j('section.view-region:in-viewport:first').addClass('inview');
    $j('.sub-nav li.active').removeClass('active');
    $j('ul.nav a[href="#'+inview+'"]').parent().addClass('active');
    $j('.sub-nav .current>span').html($j('ul.nav a[href="#'+inview+'"]').html());
}

function scroller() {
    if ( $j('body.show-top').length ) {
        return;
    }
    var scrolltop = $j(window).scrollTop();
    var currentScrollPos = window.pageYOffset;
    if ( $j('body.single-floorplan').length) {
        fpScroller();
    }
    if (scrolltop > scrolledtop && prevScrollpos < currentScrollPos) {
        if ( ! $j('body.oc-open').length && ! $j('body.oc-akel-open').length ) {
            //$j('body').addClass('scrolled');
            $j('#back-to-akel').addClass('scrolled');
        }
    } else {
        //$j('body:not(.single-floorplan)').removeClass('scrolled');
        $j('#back-to-akel').removeClass('scrolled');
    }
    if (scrolltop > scrolledtop ) {
        //$j('.scrolltop').addClass('show');
        //$j('.scrolltop:hidden').stop(true, true).fadeIn();
        $j('body').addClass('started');
    } else {
        //$j('.scrolltop').stop(true, true).fadeOut();
        //$j('.scrolltop').removeClass('show');
        $j('body').removeClass('started');
        $j('body').removeClass('scrolled');
    }
    if ( $j('div.view-region').length) {
        navScroller();
    }
    prevScrollpos = currentScrollPos;
    if ( !! $j('#solana-bay-map').length ) {
        var heights = window.innerHeight;
        document.getElementById('solana-bay-map').style.height = heights - 82 + "px";
    }

    if ( !! $j('.hero video').length ) {
        if ( $j('.hero .cover:in-viewport').length ) {
            $j('.hero-controls .play:not(.stopped)').click();
            log('play');
        } else if ( $j('.hero .cover').length ) {
            $j('.hero-controls .pause').click();
            log('pause');
        }
    }

    if ( !! $j('.videos-wrap').length ) {
        activeVideo();
    }
}

$j(window).on('resize resizeEnd', function(event) {
	// reset flying focus
    $j('#flying-focus').css({'top': 0, 'left': 0, 'right' : 0, 'bottom' : 0});
	var sizer = $j('#msizer').width();
	if ( sizer >= 30 ) {
		// Close mobile menu
        $j('li.menu-item-has-children.open').find('span.fa-minus').addClass('fa-plus').removeClass('fa-minus');
        $j('li.menu-item-has-children.open ul.sub-menu').removeAttr('style');
		$j('li.menu-item-has-children.open').removeClass('open');
		$j('#nav, #akel-nav').removeClass('com-open slide preload');
		$j('#site-overlay').hide();
		$j('#oc-akel-btn').removeClass('is-active');
		$j('body').removeClass('oc-akel-open oc-open');
		$j('.phone-nav, .akel-phone>li.open').find('a>span').text('Call Now');
		$j('.phone-nav, .akel-phone>li.open').removeClass('open');
	}
});


function updateAction() {
    var available = $j('.header-main .inner').width() - $j('.header-main div.logo').width();
    var needed = $j('#oc').outerWidth() + $j('.tablet-actions').outerWidth(true);
    var hidecount = Math.ceil(((available - needed) * -1) / 50);
    if (hidecount > 0) {
        $j('.tablet-actions .nav-sizer:not(.hide-nav)').each(function(index) {
            if (index < hidecount) {
                $j(this).addClass('hide-nav');
            }
        });
    } else {
        $j('.tablet-actions .nav-sizer.hide-nav').slice(0, hidecount * -1).removeClass('hide-nav');
    }
}

jQuery.fn.reverse = [].reverse;
$j.fn.reverse = Array.prototype.reverse;

var NAV_BUFFER = 20;
var navWidthsCached = false;
var navCollapseCount = -1;
var navComputedCount = -1;
var navMoreWidth = 0;
var navShellWidth = 0;
var navActionsShellWidth = 0;
var navCollapseUnits = [];
var topNavWidthsCached = false;
var topNavCollapseCount = -1;
var topNavComputedCount = -1;
var topNavMoreWidth = 0;
var topNavShellWidth = 0;
var topNavCollapseUnits = [];

function ensureMainMoreMenu() {
    if (!$j('#nav .menu .more-menu').length) {
        $j('#nav .menu').append('\
            <li class="more-menu last-menu menu-item-has-children hide-nav show-lg"><a href="#">\
            <span class="link">More<span class="dd far fa-plus hide-lg"></span><span class="dd fa show-lg fa-caret-down"></span></span>\
            </a><ul class="sub-menu"></ul></li>');
    }
    var $moreMenu = $j('#nav .menu .more-menu');
    $moreMenu.addClass('last-menu');
    return $moreMenu;
}

function restoreMainNavExpanded() {
    $j('#nav .in-more-menu').removeClass('in-more-menu');
    $j('#nav .hide-nav').not('.more-menu').removeClass('hide-nav');
    $j('#nav .menu .more-menu').addClass('hide-nav').find('.sub-menu').empty();
    navCollapseCount = -1;
    navComputedCount = -1;
}

function getMainNavNeeded() {
    var nav = Math.ceil($j('#nav .nav').outerWidth()) || 0;
    var actions = $j('#nav .actions').length ? Math.ceil($j('#nav .actions').outerWidth(true)) || 0 : 0;
    return nav + actions;
}

function invalidateNavWidths() {
    navWidthsCached = false;
    navCollapseCount = -1;
    navComputedCount = -1;
    $j('#nav .menu > li:not(.more-menu)').removeData('navW');
    $j('#nav .actions .nav-icon').removeData('navW');
}

function cacheNavWidths() {
    if (navWidthsCached) {
        return;
    }
    restoreMainNavExpanded();
    var $moreMenu = ensureMainMoreMenu();
    var $inner = $j('.header-main .inner');
    var prevInnerWidth = $inner.attr('style') || '';
    $inner.css('width', '99999px');
    $j('#nav .menu > li:not(.more-menu)').each(function() {
        var w = Math.ceil($j(this).outerWidth(true)) || 0;
        $j(this).data('navW', w);
    });
    $j('#nav .actions .nav-icon').each(function() {
        var w = Math.ceil($j(this).outerWidth(true)) || 0;
        $j(this).data('navW', w);
    });
    var menuWidth = 0;
    $j('#nav .menu > li:not(.more-menu)').each(function() {
        menuWidth += $j(this).data('navW') || 0;
    });
    navShellWidth = Math.max(0, (Math.ceil($j('#nav .nav').outerWidth()) || 0) - menuWidth);
    var iconsWidth = 0;
    $j('#nav .actions .nav-icon').each(function() {
        iconsWidth += $j(this).data('navW') || 0;
    });
    var actionsOuter = $j('#nav .actions').length ? Math.ceil($j('#nav .actions').outerWidth(true)) || 0 : 0;
    navActionsShellWidth = Math.max(0, actionsOuter - iconsWidth);
    $moreMenu.removeClass('hide-nav');
    navMoreWidth = Math.ceil($moreMenu.outerWidth(true)) || 0;
    $moreMenu.addClass('hide-nav');
    navCollapseUnits = [];
    $j('#nav .menu > li:not(.menu-item-has-children, .more-menu)').reverse().each(function() {
        var w = $j(this).data('navW') || 0;
        if (w <= 0) return;
        navCollapseUnits.push({
            $el: $j(this),
            width: w,
            type: 'regular',
            label: $j.trim($j(this).find('> a').text()) || 'item',
        });
    });
    $j('#nav .actions .nav-icon').each(function() {
        var w = $j(this).data('navW') || 0;
        if (w <= 0) return;
        navCollapseUnits.push({
            $el: $j(this),
            width: w,
            type: 'action',
            label: $j(this).find('a').first().find('span').first().text() || 'action',
        });
    });
    $j('#nav .menu > li.menu-item-has-children:not(.more-menu)').reverse().each(function() {
        var w = $j(this).data('navW') || 0;
        if (w <= 0) return;
        navCollapseUnits.push({
            $el: $j(this),
            width: w,
            type: 'children',
            label: $j.trim($j(this).find('> a').text()) || 'submenu',
        });
    });
    $inner.attr('style', prevInnerWidth);
    navWidthsCached = true;
}

function getExpandedNavWidth() {
    var total = navShellWidth + navActionsShellWidth;
    for (var i = 0; i < navCollapseUnits.length; i++) {
        total += navCollapseUnits[i].width;
    }
    return total;
}

function computeNavCollapseCount(available) {
    var expanded = getExpandedNavWidth();
    if (expanded <= available) {
        return 0;
    }
    var stopAt = available - NAV_BUFFER;
    var current = expanded + navMoreWidth;
    var count = 0;
    for (var i = 0; i < navCollapseUnits.length; i++) {
        if (current <= stopAt) {
            break;
        }
        current -= navCollapseUnits[i].width;
        count++;
    }
    return count;
}

function applyNavCollapse(count, available) {
    var $moreMenu = ensureMainMoreMenu();
    $j('#nav .in-more-menu').removeClass('in-more-menu');
    $j('#nav .hide-nav').not('.more-menu').removeClass('hide-nav');
    $moreMenu.find('.sub-menu').empty();
    if (count === 0) {
        $moreMenu.addClass('hide-nav');
        navCollapseCount = 0;
        logUpdateNav({ action: 'no-overflow', collapseCount: 0, available: available });
        return;
    }
    $moreMenu.removeClass('hide-nav');
    var collapsed = [];
    for (var i = 0; i < count && i < navCollapseUnits.length; i++) {
        var unit = navCollapseUnits[i];
        if (unit.type === 'regular') {
            var $clone = cleanMoreClone(unit.$el.clone(true));
            $moreMenu.find('.sub-menu').prepend($clone);
            $moreMenu.find('.sub-menu li:first-child').find('span').append('<span class="ddarrow far fa-chevron-right"></span>');
            unit.$el.addClass('hide-nav in-more-menu');
        } else if (unit.type === 'action') {
            var link = unit.$el.find('a').first().attr('href') || '#';
            var text = unit.$el.find('a').first().find('span').first().text();
            var $menuItem = $j('<li><a href="' + link + '"><span class="link">' + text + ' <span class="ddarrow far fa-chevron-right"></span></span></a></li>');
            $moreMenu.find('.sub-menu').append($menuItem);
            unit.$el.addClass('hide-nav in-more-menu');
        } else if (unit.type === 'children') {
            unit.$el.find('> ul.sub-menu > li').each(function() {
                $moreMenu.find('.sub-menu').append(cleanMoreClone($j(this).clone()));
            });
            unit.$el.addClass('hide-nav in-more-menu');
        }
        collapsed.push(unit.label);
    }
    if ($moreMenu.find('.sub-menu > li').length === 0) {
        $moreMenu.addClass('hide-nav');
        $j('#nav .in-more-menu').removeClass('in-more-menu');
        $j('#nav .hide-nav').not('.more-menu').removeClass('hide-nav');
        navCollapseCount = 0;
        logUpdateNav({ action: 'collapse-failed', available: available });
        return;
    }
    navCollapseCount = count;
    logUpdateNav({ action: 'collapsed', collapseCount: count, available: available, collapsed: collapsed });
}

function cleanMoreClone($clone) {
    $clone.removeClass('hide-nav in-more-menu');
    return $clone;
}

function logUpdateNav(data) {
    if (window.navDebug) {
        console.log('[updateNav]', data);
    }
}

function updateNav() {
    if ($j('#msizer').width() < 30) {
        restoreMainNavExpanded();
        return;
    }
    cacheNavWidths();
    var innerWidth = $j('.header-main .inner').width() || 0;
    var logoWidth = $j('.header-main div.logo').outerWidth(true) || 0;
    var available = innerWidth - logoWidth;
    var count = computeNavCollapseCount(available);
    if (count !== navComputedCount) {
        navComputedCount = count;
        applyNavCollapse(count, available);
    }
    var guard = 0;
    while (getMainNavNeeded() > available && navCollapseCount < navCollapseUnits.length && guard < 30) {
        applyNavCollapse(navCollapseCount + 1, available);
        guard++;
    }
}

var navloaded = 0;

function ensureTopMoreMenu(nav) {
    if (!nav.find('ul .more-menu').length) {
        nav.find('nav > div > ul').append('\
            <li class="more-menu right-menu menu-item-has-children hide-nav show-lg"><a href="#">\
            <span class="link">More<span class="dd far fa-plus hide-lg"></span><span class="dd fa show-lg fa-caret-down"></span></span>\
            </a><ul class="sub-menu"></ul></li>');
    }
    return nav.find('ul .more-menu');
}

function invalidateTopNavWidths() {
    topNavWidthsCached = false;
    topNavCollapseCount = -1;
    topNavComputedCount = -1;
}

function cacheTopNavWidths(nav) {
    if (topNavWidthsCached) {
        return;
    }
    nav.find('.in-more-menu').removeClass('in-more-menu');
    nav.find('.hide-nav').not('.more-menu').removeClass('hide-nav');
    var $moreMenu = ensureTopMoreMenu(nav);
    $moreMenu.find('.sub-menu').empty();
    $moreMenu.addClass('hide-nav');
    var $items = nav.find('nav > div > ul > li:not(.more-menu)');
    $items.each(function() {
        var w = Math.ceil($j(this).outerWidth(true)) || 0;
        $j(this).data('topNavW', w);
    });
    var menuWidth = 0;
    $items.each(function() {
        menuWidth += $j(this).data('topNavW') || 0;
    });
    topNavShellWidth = Math.max(0, (Math.ceil(nav.find('nav').outerWidth(true)) || 0) - menuWidth);
    $moreMenu.removeClass('hide-nav');
    topNavMoreWidth = Math.ceil($moreMenu.outerWidth(true)) || 0;
    $moreMenu.addClass('hide-nav');
    topNavCollapseUnits = [];
    nav.find('nav > div > ul > li:not(.menu-item-has-children, .more-menu)').reverse().each(function() {
        topNavCollapseUnits.push({
            $el: $j(this),
            width: $j(this).data('topNavW') || 0,
            type: 'regular',
        });
    });
    nav.find('nav > div > ul > li.menu-item-has-children:not(.more-menu)').reverse().each(function() {
        topNavCollapseUnits.push({
            $el: $j(this),
            width: $j(this).data('topNavW') || 0,
            type: 'children',
        });
    });
    topNavWidthsCached = true;
}

function getExpandedTopNavWidth() {
    var total = topNavShellWidth;
    for (var i = 0; i < topNavCollapseUnits.length; i++) {
        total += topNavCollapseUnits[i].width;
    }
    return total;
}

function computeTopNavCollapseCount(available) {
    var expanded = getExpandedTopNavWidth();
    if (expanded <= available) {
        return 0;
    }
    var stopAt = available - NAV_BUFFER;
    var current = expanded + topNavMoreWidth;
    var count = 0;
    for (var i = 0; i < topNavCollapseUnits.length; i++) {
        if (current <= stopAt) {
            break;
        }
        current -= topNavCollapseUnits[i].width;
        count++;
    }
    return count;
}

function applyTopNavCollapse(nav, count) {
    var $moreMenu = ensureTopMoreMenu(nav);
    nav.find('.in-more-menu').removeClass('in-more-menu');
    nav.find('.hide-nav').not('.more-menu').removeClass('hide-nav');
    $moreMenu.find('.sub-menu').empty();
    if (count === 0) {
        $moreMenu.addClass('hide-nav');
        topNavCollapseCount = 0;
        $j('.top-nav').addClass('loaded');
        return;
    }
    $moreMenu.removeClass('hide-nav');
    for (var i = 0; i < count && i < topNavCollapseUnits.length; i++) {
        var unit = topNavCollapseUnits[i];
        if (unit.type === 'regular') {
            var $clone = unit.$el.clone(true);
            $moreMenu.find('.sub-menu').prepend($clone);
            $moreMenu.find('.sub-menu li:first-child').find('span').append('<span class="ddarrow far fa-chevron-right"></span>');
            unit.$el.addClass('hide-nav in-more-menu');
        } else if (unit.type === 'children') {
            unit.$el.find('> ul.sub-menu > li').each(function() {
                $moreMenu.find('.sub-menu').append($j(this).clone());
            });
            unit.$el.addClass('hide-nav in-more-menu');
        }
    }
    if ($moreMenu.find('.sub-menu > li').length === 0) {
        $moreMenu.addClass('hide-nav');
        nav.find('.in-more-menu').removeClass('in-more-menu');
        topNavCollapseCount = 0;
        return;
    }
    topNavCollapseCount = count;
}

function updateTopNav() {
    if (!$j('.top-nav nav').length) {
        return;
    }
    var akela = $j('.akel-logo').width() || 0;
    var navoffset = 100;
    var elements = ($j('.top-logo').width() + akela + navoffset + $j('.top-tagline').width()) || 0;
    var available = $j('.header-top > .inner').width() - (elements);
    var nav = $j('.top-nav');
    cacheTopNavWidths(nav);
    var count = computeTopNavCollapseCount(available);
    if (count !== topNavComputedCount) {
        topNavComputedCount = count;
        applyTopNavCollapse(nav, count);
    }
    var guard = 0;
    while ((Math.ceil(nav.find('nav').outerWidth(true)) || 0) > available && topNavCollapseCount < topNavCollapseUnits.length && guard < 30) {
        applyTopNavCollapse(nav, topNavCollapseCount + 1);
        guard++;
    }
    if (!$j('.top-nav').hasClass('loaded')) {
        clearTimeout(navloaded);
        navloaded = setTimeout(() => {
            $j('.top-nav').addClass('loaded');
        }, 200);
    }
}
var processNav = (function() {
    var frame;
    var frame2;
    return function() {
        if (frame2) cancelAnimationFrame(frame2);
        frame2 = requestAnimationFrame(updateTopNav);
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateNav);
    };
})();

var resizing = 0;
$j(window).on('resize resizeEnd', function(event) {
	// reset flying focus
    //$j('#flying-focus').css({'top': 0, 'left': 0, 'right' : 0, 'bottom' : 0});
	var sizer = $j('#msizer').width();
    if ( sizer < 30) {
        updateAction();
    } else {
        $j('body').addClass('resizing');
        clearTimeout(resizing);
        resizing = setTimeout(() => {
            $j('body').removeClass('resizing');
        }, 500);
    }
});
const NavManager = (function($j) {
    function init(processNav) {
        function scheduleNav() {
            var sizer = $j('#msizer').width();
            if (sizer < 30) {
                return;
            }
            processNav();
        }
        $j(document).ready(function() {
            invalidateNavWidths();
            invalidateTopNavWidths();
            scheduleNav();
        });
        $j(window).on('load', function() {
            invalidateNavWidths();
            invalidateTopNavWidths();
            scheduleNav();
        });
        $j(window).on('resize orientationchange', scheduleNav);
        $j(document).on('visibilitychange', function() {
            if (!document.hidden) {
                scheduleNav();
            }
        });
        if (window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(scheduleNav);
            const headerInner = document.querySelector('.header-main .inner');
            if (headerInner) {
                resizeObserver.observe(headerInner);
            }
        }
    }
    return { init };
})($j);
NavManager.init(processNav);
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
        invalidateNavWidths();
        invalidateTopNavWidths();
        processNav();
    });
}
